<template>
    <div class="grid grid-cols-3 text-center text-a-gray-a4a4a4 font-regular cursor-pointer select-none mt-2" v-show="isShowCode" data-cy="container_serial_tabs">
        <div class="border-b-2 py-1.5 "
             data-cy="btn_serial_tab_code"
             :class="[serialType == 'CODE' ? classActiveTab : '']"
             @click="changeTab('CODE')">
            {{lbl.serial.code}}
        </div>
        <div class="border-b-2 py-1.5"
             data-cy="btn_serial_tab_qr_code"
             :class="[serialType == 'QR_CODE' ? classActiveTab : '']"
             @click="changeTab('QR_CODE')">
            {{lbl.serial.qr_code}}
        </div>
        <div class="border-b-2 py-1.5"
             data-cy="btn_serial_tab_barcode"
             :class="[serialType == 'CODE_128' ? classActiveTab : '']"
             @click="changeTab('CODE_128')">
            {{lbl.serial.barcode}}
        </div>
    </div>
    <div class="flex justify-center wrap-code bg-a-blue-f2f5ff relative" data-cy="container_serial_code">
        <div v-if="isExpired || isStaff" class="absolute m:top-16 xs:top-14 left-0 right-0 w-full h-12 bg-a-blue-f2f5ff m-auto p-3 z-10"
            :class="{'m:top-20 xs:top-16': serialType == 'QR_CODE', 'used-code': serialType == 'CODE_128'}">
            <div class="flex justify-center" v-if="isExpired && !isUsed">
                <div>
                    <img src="@/assets/icon/ic-warning.svg">
                </div>
                <div class="text-center text-a-red-ff4d4d text-20 font-bold ml-1">
                    {{lbl.serial.camp_expire}}
                </div>
            </div>
            <div class="flex justify-center" v-if="isStaff || isUsed">
                <div>
                    <img src="@/assets/icon/ic_warning_used.svg">
                </div>
                <div class="text-center text-a-blue-2140a6 text-20 font-bold ml-1">
                    {{lbl.serial.camp_used}}
                </div>
            </div>
        </div>
        <div v-show="serialType == 'CODE'" :class="{'opacity-20 bg-a-blue-f2f5ff': isExpired || isStaff}">
            <div class="text-a-blue-2140a6 font-bold all-size mb-3 text-center long-code" data-cy="text_serial_code">{{serial}}</div>
            <div class="border border-a-blue-2140a6 w-28 h-7 rounded-sm px-3 py-0.5 m-auto">
                <button class="btn-copy" data-cy="btn_serial_copy_code" v-clipboard:copy="serial"
                        @click="onCopy($event)">
                        <div class="size-text text-a-blue-2140a6 font-bold">{{lbl.serial.copy_code}}</div>
                </button>
            </div>
        </div>
        <div v-show="serialType == 'QR_CODE'" class="m:mt-9 xs:mt-4" :class="{'opacity-20 bg-a-blue-f2f5ff': isExpired  || isStaff}">
            <VueQrcode :value="serial" :options="qrOption"></VueQrcode>
        </div>
        <div v-show="serialType == 'CODE_128'" class="m:mt-10 xs:mt-4" :class="{'opacity-20 bg-a-blue-f2f5ff mt-1.5': isExpired  || isStaff}">
            <VueBarcode id="barcode" :value="serial" :options="barcodeOption"></VueBarcode>
        </div>
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ModalMixin from '@/mixin/ModalMixin';
//lib
import VueBarcode from '@chenfengyuan/vue-barcode';
import VueQrcode from '@chenfengyuan/vue-qrcode';
export default {
    name: "Serial",
    mixins: [LocaleMixin, ModalMixin],
    components: {
        VueBarcode,
        VueQrcode,
    },
    props: {
        serialModel: Object,
        isStaff: Boolean,
        isUsed: Boolean,
    },
    data: function() {
        return {
            serialType: 'CODE', // CODE, QR_CODE, CODE_128
            classActiveTab: 'text-a-blue-2140a6 border-a-blue-2140a6',

            isExpired: false,
            isLoaded: false,
            isShowCode: true,
            isTabLock: false,
            privilegeMsg: '',
            serial: '',

            qrOption: {
                width: 130,
                height: 130,
                margin: 0,
            },
            barcodeOption: {
                height: 100,
                displayValue: false,
                lineColor: '#000000',
                width: 1,
            },
        };
    },
    created: function() {
        this.initial();
    },
    methods: {
        initial: function () {
            if (!this.serialModel.serial) {
                return;
            }

            this.serial = this.serialModel.serial;
            if(this.serial == 'XXXXXXX'){
                this.isExpired = true;
            }
            switch (this.serialModel.serialType) {
                case 'CODE_128':
                    this.serialType = 'CODE_128';
                    break;
                case 'QR_CODE':
                    this.serialType = 'QR_CODE';
                    break;
                default:
                    this.serialType = 'CODE';
                    break;
            }

            if (this.serialModel.serialType && this.serialModel.serialType.toLowerCase() == 'none' && this.serialModel.privilegeMessage) {
                this.isShowCode = false;
            }
        },

        changeTab: function (type) {
            if (this.isTabLock) return;

            this.serialType = type;

            let tracking_category = '';
            let tracking_action = '';
            switch (type) {
                case 'CODE_128':
                    tracking_category = 'campaign_serail_barcode';
                    tracking_action = 'click_barcode';
                    break;
                case 'QR_CODE':
                    tracking_category = 'campaign_serail_qrcode';
                    tracking_action = 'click_qrcode';
                    break;
                case 'CODE':
                    tracking_category = 'campaign_serail_code';
                    tracking_action = 'click_code';
                    break;
            }
            this.tracking.event(tracking_category, tracking_action, this.serialModel.campaignId, null);

        },

        setSerialExpire: function() {
            this.serial = "XXXXXXXX";
            this.isExpired = true;
            this.isTabLock = false;
            this.serialType = "CODE";
        },
        onCopy: function() {
            // on copy serial event
            this.tracking.event('campaign_serail_copy_code', 'click_copy_code', this.serialModel.campaignId, null);
            this.modal.copySerialSuccessModal
                            .clearModal()
                            .show()
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
.wrap-code {
    height: 270px;
    margin: auto;
    .used-code {
        top: 4.8rem;
        @include size-mini-mobile {
            top: 3.5rem;
        }
    }

    @include size-mini-mobile {
        height: 225px;
    }

    .long-code {
        padding: 0 20px;
        word-break: break-all;
    }

    #barcode {
        width: 100%;
        max-height: 150px;
        padding: 0 20px
    }

    .btn-copy {
        background-image: url('../../../../../assets/icon/ic-copy.svg');
        background-repeat: no-repeat;
        background-size: 15px 17px;
        background-position: left;

        .size-text {
            margin-left: 1rem;
            font-size: 0.875rem;
            @include size-mini-mobile {
                margin-left: 1rem;
            }
        }
    }

    .all-size {
        font-size: 1.375rem;
        margin-top: 3rem;

        @include size-mini-mobile {
            font-size: 0.875rem;
        }
    }
}
</style>
